@if(field(); as field)
{
<div class="input-group">
	<span class="input-group-text">
		@if(field.saving()){<i class="fa-fw fa-regular fa-spin fa-spinner-third"></i>}
		@else if(errorToShow() !== ''){<i class="fa-fw fa-solid fa-circle-xmark color-darkred"></i>}
		@else{<i class="fa-fw fa-regular fa-location-dot"></i>}
	</span>
	<div class="eforall-common-field form-floating">
		<input type="text" class="form-control" #addressField [id]="randomId" [placeholder]="field.config().label" autocomplete="new-google-address"
			[ngModel]="renderedModel()" (ngModelChange)="onInputChange($event)" [disabled]="field.saving()" (blur)='onBlur()' (focus)="onFocus()" (keydown)="onKeyDown($event)">
		<label class="color-gray d-flex" [for]="randomId">
			{{field.config().label}}{{!field.config().isRequired ? ' ' + labels().optionalWithParentheses():''}}
		</label>
		
		<!-- Suggestions Dropdown -->
		@if(suggestions().length){
			<ul class="list-group position-absolute w-100 shadow">
				@for(s of suggestions(); track $index; let i = $index){
				<!-- preventDefault for mouseDown - keeps input focused -->
				<li class="list-group-item list-group-item-action"
					[class.active]="i === highlighted()" (mousedown)="$event.preventDefault()" (mouseenter)="highlighted.set(i)" (click)="onAddressSelection(s)">
					{{ s.placePrediction?.text?.text }}
				</li>
				}
			</ul>
		}
	</div>
</div>

@if(errorToShow() !== '')
{
<div class="color-darkred text-end">{{errorToShow()}}</div>
}
}